export default __webpack_public_path__ + "static/media/icon-link.c5e6cc9b.svg";